import { readable, writable } from "svelte/store";

export const settings = writable({
  size: 50,
  rotateX: -20,
  rotateY: -40,
});

export const tiles = readable([
  { color: "#C41E3A", slug: "front", rotateX: 0, rotateY: 0 },
  { color: "#FF5800", slug: "right", rotateX: 0, rotateY: 90 },
  { color: "#0051BA", slug: "back", rotateX: 0, rotateY: 180 },
  { color: "#DDDDDD", slug: "left", rotateX: 0, rotateY: -90 },
  { color: "#009E60", slug: "top", rotateX: 90, rotateY: 0 },
  { color: "#FFD500", slug: "bottom", rotateX: -90, rotateY: 0 },
]);

export const pieces = writable([
  {
    id: 1,
    translateX: 0,
    translateY: 0,
    translateZ: 0,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "left",
    y: "top",
    z: "back",
  },
  {
    id: 2,
    translateX: 0,
    translateY: 1,
    translateZ: 0,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "left",
    y: "center",
    z: "back",
  },
  {
    id: 3,
    translateX: 0,
    translateY: 2,
    translateZ: 0,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "left",
    y: "bottom",
    z: "back",
  },
  {
    id: 4,
    translateX: 1,
    translateY: 0,
    translateZ: 0,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "center",
    y: "top",
    z: "back",
  },
  {
    id: 5,
    translateX: 1,
    translateY: 1,
    translateZ: 0,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "center",
    y: "center",
    z: "back",
  },
  {
    id: 6,
    translateX: 1,
    translateY: 2,
    translateZ: 0,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "center",
    y: "bottom",
    z: "back",
  },
  {
    id: 7,
    translateX: 2,
    translateY: 0,
    translateZ: 0,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "right",
    y: "top",
    z: "back",
  },
  {
    id: 8,
    translateX: 2,
    translateY: 1,
    translateZ: 0,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "right",
    y: "center",
    z: "back",
  },
  {
    id: 9,
    translateX: 2,
    translateY: 2,
    translateZ: 0,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "right",
    y: "bottom",
    z: "back",
  },
  {
    id: 10,
    translateX: 0,
    translateY: 0,
    translateZ: 1,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "left",
    y: "top",
    z: "center",
  },
  {
    id: 11,
    translateX: 0,
    translateY: 1,
    translateZ: 1,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "left",
    y: "center",
    z: "center",
  },
  {
    id: 12,
    translateX: 0,
    translateY: 2,
    translateZ: 1,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "left",
    y: "bottom",
    z: "center",
  },
  {
    id: 13,
    translateX: 1,
    translateY: 0,
    translateZ: 1,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "center",
    y: "top",
    z: "center",
  },
  {
    id: 14,
    translateX: 1,
    translateY: 1,
    translateZ: 1,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "center",
    y: "center",
    z: "center",
  },
  {
    id: 15,
    translateX: 1,
    translateY: 2,
    translateZ: 1,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "center",
    y: "bottom",
    z: "center",
  },
  {
    id: 16,
    translateX: 2,
    translateY: 0,
    translateZ: 1,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "right",
    y: "top",
    z: "center",
  },
  {
    id: 17,
    translateX: 2,
    translateY: 1,
    translateZ: 1,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "right",
    y: "center",
    z: "center",
  },
  {
    id: 18,
    translateX: 2,
    translateY: 2,
    translateZ: 1,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "right",
    y: "bottom",
    z: "center",
  },
  {
    id: 19,
    translateX: 0,
    translateY: 0,
    translateZ: 2,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "left",
    y: "top",
    z: "front",
  },
  {
    id: 20,
    translateX: 0,
    translateY: 1,
    translateZ: 2,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "left",
    y: "center",
    z: "front",
  },
  {
    id: 21,
    translateX: 0,
    translateY: 2,
    translateZ: 2,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "left",
    y: "bottom",
    z: "front",
  },
  {
    id: 22,
    translateX: 1,
    translateY: 0,
    translateZ: 2,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "center",
    y: "top",
    z: "front",
  },
  {
    id: 23,
    translateX: 1,
    translateY: 1,
    translateZ: 2,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "center",
    y: "center",
    z: "front",
  },
  {
    id: 24,
    translateX: 1,
    translateY: 2,
    translateZ: 2,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "center",
    y: "bottom",
    z: "front",
  },
  {
    id: 25,
    translateX: 2,
    translateY: 0,
    translateZ: 2,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "right",
    y: "top",
    z: "front",
  },
  {
    id: 26,
    translateX: 2,
    translateY: 1,
    translateZ: 2,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "right",
    y: "center",
    z: "front",
  },
  {
    id: 27,
    translateX: 2,
    translateY: 2,
    translateZ: 2,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    x: "right",
    y: "bottom",
    z: "front",
  },
]);
